import Slider from "./Slider";

import { SwiperOptions, Navigation } from "swiper";

// Snapshot tailwind config with babel-plugin-preval
const tailwindScreens = preval`
    const resolveConfig = require('tailwindcss/resolveConfig');
    const tailwindConfig = require('./../../../tailwind.config.js');

    const fullConfig = resolveConfig(tailwindConfig)
    module.exports = fullConfig.theme.screens;
`;


export default class extends Slider {
    constructor(m) {
        super(m);

        /** @type {SwiperOptions} */
        this.config = {
            // Optional parameters
            modules: [Navigation],
            slidesPerView: 1,
            speed: 500,
            pagination: null,
            enabled: true,
            breakpoints: {
                [parseInt(tailwindScreens.lg)]: {
                    enabled: false,
                    slidesPerView: 'auto'
                }
            },
        }
        

    }

    onInit() {}

    onResize() {
        this.toggleEnabledBySize();
    }

    toggleEnabledBySize() {
        const navigationBreakpoint = parseInt(tailwindScreens.lg);
        this.el.classList.toggle('-swiper-disabled', window.innerWidth >= navigationBreakpoint);
    }
    
    bindEvents(el) {}

    update(newContainer) {}

    destroy(oldContainer) {}
}
